import {
    type FC
} from "react";
import {
    View
} from "react-native";
import type IInputGroupSpinnerProps from "./type";
import {
    NCoreUIKitTheme
} from "../../../../core/hooks";
import {
    useInputGroupContext
} from "../../context";
import stylesheet, {
    getInputGroupIconColor,
    useStyles
} from "../../stylesheet";
import Loading from "../../../loading";

const InputGroupSpinner: FC<IInputGroupSpinnerProps> = ({
    style
}) => {
    const {
        currentSize,
        customTheme,
        isDisabled
    } = useInputGroupContext();

    const {
        colors,
        spaces
    } = NCoreUIKitTheme.useContext(customTheme);

    const {
        spinner: spinnerDynamicStyle
    } = useStyles({
        currentSize,
        spaces
    });

    return <View
        style={[
            style,
            stylesheet.spinner,
            spinnerDynamicStyle
        ]}
    >
        <Loading
            customColor={getInputGroupIconColor({
                isDisabled,
                colors
            })}
            size={currentSize.iconSize}
            customTheme={customTheme}
        />
    </View>;
};
export default InputGroupSpinner;
